export enum FileUploadAttribute {
  Multiple = 'multiple',
  Accept = 'accept',
  Size = 'size',
  Disabled = 'disabled'
}
